"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignalFloatingBehaviourDenormalizedSchema = void 0;
exports.getSignalFloatingBehavioursInDenormalizedFormat = getSignalFloatingBehavioursInDenormalizedFormat;
exports.applyFloatingBehavioursToSignals = applyFloatingBehavioursToSignals;
const zod_1 = require("zod");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
exports.SignalFloatingBehaviourDenormalizedSchema = zod_1.z
    .object({
    signalName: zod_1.z.string(),
    floatingBehaviour: zod_1.z.nativeEnum(sigma_engine_shared_1.SignalFloatingBehavior).nullable(),
    evidence: zod_1.z.string().nullable(),
})
    .strict();
function getSignalFloatingBehavioursInDenormalizedFormat(signals) {
    return signals.map((signal) => ({
        signalName: signal.name,
        floatingBehaviour: signal.floatingBehavior ?? null,
        evidence: '',
    }));
}
function applyFloatingBehavioursToSignals(signals, floatingBehaviours, logger = (0, sigma_engine_shared_1.generateCompatibleConsoleLogger)()) {
    const floatingBehaviourMap = new Map();
    const availableSignalNames = signals.map((s) => s.name);
    for (const behaviour of floatingBehaviours) {
        const matchingSignal = signals.find((s) => s.name === behaviour.signalName);
        if (!matchingSignal) {
            logger.warn('ApplyFloatingBehavioursToSignals_SignalNotFound', {
                signalName: behaviour.signalName,
                availableSignalNames,
            });
            continue;
        }
        if (matchingSignal.floatingBehavior !== undefined &&
            matchingSignal.floatingBehavior !== behaviour.floatingBehaviour) {
            logger.warn('ApplyFloatingBehavioursToSignals_OverwritingExistingValue', {
                signalName: matchingSignal.name,
                existingValue: matchingSignal.floatingBehavior,
                newValue: behaviour.floatingBehaviour,
            });
        }
        floatingBehaviourMap.set(behaviour.signalName, behaviour.floatingBehaviour);
    }
    return signals.map((signal) => {
        const behaviour = floatingBehaviourMap.get(signal.name);
        if (behaviour === undefined) {
            return signal;
        }
        return {
            ...signal,
            floatingBehavior: behaviour ?? undefined,
        };
    });
}
//# sourceMappingURL=signal-float-behaviour-denormalized.js.map